import { Injectable, NgZone } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GooglePlacesService {
  private searchBox$: Observable<google.maps.places.Autocomplete>;
  private readonly googlePlace$$: BehaviorSubject<google.maps.places.PlaceResult> = new BehaviorSubject(null);
  public googlePlace$: Observable<google.maps.places.PlaceResult> = this.googlePlace$$.asObservable();

  constructor(private readonly ngZone: NgZone) {}

  public init(htmlElement: HTMLInputElement, defaultBounds: google.maps.LatLngBounds = null): void {
    const loader = new Loader({
      apiKey: 'AIzaSyDqWGgrDbTRHlVwo_ViFD05agVFY7Do7zI',
      libraries: ['places'],
      version: 'quarterly',
    });
    this.searchBox$ = from(loader.load()).pipe(
      map((google) => new google.maps.places.Autocomplete(htmlElement, { bounds: defaultBounds })),
      shareReplay(1),
    );
    this.initSearchBox();
  }
  private initSearchBox(): void {
    this.searchBox$
      .pipe(
        map((searchbox) => {
          searchbox.setFields([
            'address_component',
            'adr_address',
            'business_status',
            'formatted_address',
            'geometry.location',
            'icon',
            'name',
            'place_id',
            'type',
            'url',
            'formatted_phone_number',
            'opening_hours',
            'website',
          ]);
          searchbox.addListener('place_changed', () => {
            this.ngZone.run(() => {
              const place: google.maps.places.PlaceResult = searchbox.getPlace();
              this.setGooglePlaces(place);
            });
          });
        }),
      )
      .subscribe();
  }
  public setGooglePlaces(places: google.maps.places.PlaceResult): void {
    this.googlePlace$$.next(places);
  }

  destroy(): void {
    this.googlePlace$$.complete();
  }
}
